/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chatplaceholdertype2Inputs */

const en_chatplaceholdertype2 = /** @type {(inputs: Chatplaceholdertype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type a message…`)
};

const pt_chatplaceholdertype2 = /** @type {(inputs: Chatplaceholdertype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escreve uma mensagem…`)
};

/**
* | output |
* | --- |
* | "Type a message…" |
*
* @param {Chatplaceholdertype2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const chatplaceholdertype2 = /** @type {((inputs?: Chatplaceholdertype2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chatplaceholdertype2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chatplaceholdertype2(inputs)
	return pt_chatplaceholdertype2(inputs)
});
export { chatplaceholdertype2 as "chatPlaceholderType" }